import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  MDS_HEATWAVE_DELETE_POLL_DELAY,
  MDS_HEATWAVE_DELETE_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface MysqlDeleteHeatWaveProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const MysqlDeleteHeatWave = (
  { location, databaseId, onExecute }: MysqlDeleteHeatWaveProps,
): JSX.Element => {
  const { invokeCall: invokeDelete } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.deleteHeatWaveCluster },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resourceGroupName = decodeURIComponent(resourceGroup || "");
    const dbSystemName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.deleteHeatWave(),
          message: Messages.notifications.inProgress.messages.deleteHeatWave(dbSystemName),
        },
        success: {
          title: Messages.notifications.success.titles.deleteHeatWave(),
          message: Messages.notifications.success.messages.deleteHeatWave(dbSystemName),
        },
        failure: {
          title: Messages.notifications.failure.titles.delete(),
          message: Messages.notifications.failure.messages.deleteHeatWave(dbSystemName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.MDS_HEATWAVE_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName,
            dbSystemName,
          },
          location,
          errorStatusOverrides: [404],
          responseMethodKey: AsyncNotificationPolledResponseKey.MDS_HEATWAVE_DELETED_CHECK,
          delay: MDS_HEATWAVE_DELETE_POLL_DELAY,
          interval: MDS_HEATWAVE_DELETE_POLL_INTERVAL,
        },
      },
    };
    invokeDelete({
      subscriptionId,
      resourceGroupName,
      dbSystemName,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newMysqlDeleteHeatWave = (
  props: MysqlDeleteHeatWaveProps,
): JSX.Element => (<MysqlDeleteHeatWave {...props} />);
